import { DefaultService } from '@/services/DefaultService';

export default class UsuarioObjetivoVendaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    getAll(filtros) {
        return this._http
                   .post(`${this._env}/report-sales/result-objective`, filtros, this._headers)
                   .then(res => res.body, this.handleError);
    }

    getPedidosByUsuario(idusuario, filtros) {
        return this._http
                   .post(`${this._env}/report-sales/result-objective/orders/${idusuario}`, filtros, this._headers)
                   .then(res => res.body, this.handleError);
    }

}